<div class="container p-3">
    <div class="row">
        <div class="col">
            <div>
                <button class="btn btn-outline-secondary" (click)="navigateToCommunity()">
                    <i class="fas fa-chevron-left"></i> Back
                </button>
            </div>
        </div>
    </div>
    <hr>
    <div class="row">
        <div class="col-12 col-sm-10 offset-sm-1 col-md-8 offset-md-2 col-lg-6 offset-lg-3">
            <div>
                <community-comment-card [comment]="comment" (updateUser)="updateUser($event)"></community-comment-card>
                <hr>
            </div>
        </div>
    </div>
</div>